export default "__VITE_ASSET__7cc4c876__"